// extracted by mini-css-extract-plugin
module.exports = {"header-logo":"styles-module__header-logo___x85ZH","main-image":"styles-module__main-image___1Rhsy"};